<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ service.getParentID() ? 'Edit service' : 'Create a service' }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylists"
    (click)="loadServices()"
  >
  </salonmonster-tap-retry>

  <form
    [formGroup]="serviceParentForm"
    *ngIf="!isLoading && !errorOccurredWhileLoadingStylists"
  >
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="6" size-xl="6">
        <div>
          <ion-item tappable lines="none" (click)="showServiceCategoryPicker()">
            <ion-label position="stacked"
              >Service Category</ion-label
            >
            <ion-input
              value="{{service.getServiceCategory() ?
              service.getServiceCategory().categoryName : 'Select a category'}}"
            >
            </ion-input>
          </ion-item>

          <ion-item
            *ngIf="!service.serviceCategory && submitAttempt"
            lines="none"
          >
            <p class="sm-error">Service Category is required.</p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked">Service name</ion-label>
            <ion-input
              type="text"
              name=""
              formControlName="serviceName"
              class="smr-input-border"
              clearInput
            ></ion-input>
          </ion-item>

          <ion-item *ngIf="!serviceName.valid && submitAttempt" lines="none">
            <p *ngIf="serviceName.hasError('required')" class="sm-error">
              Service name is required.
            </p>
          </ion-item>

          <ion-item lines="none">
            <ion-label position="stacked">Description</ion-label>
            <ion-textarea
              type="text"
              name=""
              formControlName="description"
              class="smr-input-border"
              clearInput
            ></ion-textarea>
          </ion-item>
          <ion-grid class="ion-no-padding">
            <ion-row>
              <ion-col size="11">
                <ion-item lines="none">
                  <ion-label class="sm-bold"
                    >Show prices as "Starting at"</ion-label
                  >
                  <ion-checkbox
                    formControlName="startingAt"
                    clearInput
                  ></ion-checkbox>
                </ion-item>
              </ion-col>
              <ion-col size="1" class="sm-align-vertical">
                <ion-icon
                  id="starting-hover-trigger"
                  name="help-circle"
                  color="faint"
                  arrow="true"
                ></ion-icon>
                <ion-popover
                  trigger="starting-hover-trigger"
                  triggerAction="hover"
                  side="right"
                  alignment="end"
                  size="auto"
                >
                  <ng-template>
                    <ion-content class="ion-padding"
                      >This will show prices as 'Starting at $100' (for example)
                      on your client booking page.</ion-content
                    >
                  </ng-template>
                </ion-popover>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>

    <ion-row *ngFor="let stylistControls of stylistFormControls">
      <ion-col class="hidden-sm-down"></ion-col>
      <ion-col size="12" size-sm="12" size-md="8" size-lg="6" size-xl="6">
        <ion-card [class.sm-card-flat]="salonStylists.count() == 1">
          <ion-item [hidden]="salonStylists.count() == 1" lines="none">
            <ion-label class="sm-card-header">
              {{ stylistControls.stylist.getFirstName() }} {{
              stylistControls.stylist.getLastName() }}
            </ion-label>
            <ion-toggle
              [formControlName]="ACTIVE_CONTROL_PREFIX + stylistControls.stylist.getID()"
            ></ion-toggle>
          </ion-item>

          <ng-container
            *ngIf="stylistControls.active.value || salonStylists.count() == 1"
          >
            <!--             <ion-item>
              <ion-label stacked>Price {{currency}}</ion-label>
              <ion-input 
                type="number" 
                name='' 
                [formControlName]="PRICE_CONTROL_PREFIX + stylistControls.stylist.getID()" 
                clearInput>
              </ion-input>
            </ion-item> -->

            <ion-item lines="none">
              <ion-label position="stacked">Price</ion-label>
              <ion-input
                placeholder="Enter price"
                [maskito]="currencyMask"
                [maskitoElement]="maskPredicate"
                [formControlName]="PRICE_CONTROL_PREFIX + stylistControls.stylist.getID()"
              >
              </ion-input>
            </ion-item>

            <ion-item
              *ngIf="!stylistControls.price.valid && submitAttempt"
              lines="none"
            >
              <p
                *ngIf="stylistControls.price.hasError('required')"
                class="sm-error"
              >
                Price is required.
              </p>
            </ion-item>
            <ion-grid class="ion-no-padding">
              <ion-row position="stacked">
                <ion-col size="11">
                  <ion-item lines="none">
                    <ion-label class="sm-bold"
                      >Bookback/Split appointment</ion-label
                    >
                    <!-- <ion-toggle 
                      [formControlName]="BOOKBACK_CONTROL_PREFIX + stylistControls.stylist.getID()" 
                      >
                    </ion-toggle> -->
                    <ion-checkbox
                      [formControlName]="BOOKBACK_CONTROL_PREFIX + stylistControls.stylist.getID()"
                    >
                    </ion-checkbox>
                  </ion-item>
                </ion-col>
                <ion-col size="1" class="sm-align-vertical">
                  <ion-icon
                    id="bookback-hover-trigger"
                    name="help-circle"
                    color="faint"
                    arrow="true"
                  ></ion-icon>
                  <ion-popover
                    trigger="bookback-hover-trigger"
                    triggerAction="hover"
                    side="right"
                    alignment="end"
                    size="auto"
                  >
                    <ng-template>
                      <ion-content class="ion-padding"
                        >A bookback or split appointment allows you to set a
                        start duration, a processing duration and a finishing
                        duration. During the processing duration another client
                        can be booked into the calendar allowing you to fit more
                        clients into your day.</ion-content
                      >
                    </ng-template>
                  </ion-popover>
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-item lines="none">
              <ion-label position="stacked">Duration</ion-label>
              <ion-select
                [formControlName]="START_DURATION_CONTROL_PREFIX + stylistControls.stylist.getID()"
              >
                <ion-select-option
                  *ngFor="let timeslot of timeSlots"
                  [value]="timeslot.value"
                >
                  {{timeslot.label}}
                </ion-select-option>
              </ion-select>
            </ion-item>

            <ion-item
              *ngIf="!stylistControls.startDuration.valid && submitAttempt"
              lines="none"
            >
              <p
                *ngIf="stylistControls.startDuration.hasError('required')"
                class="sm-error"
              >
                Start Duration is required.
              </p>
            </ion-item>

            <div *ngIf="stylistControls.bookback.value">
              <ion-item lines="none">
                <ion-label position="stacked">Process Duration</ion-label>
                <ion-select
                  [formControlName]="PROCESS_DURATION_CONTROL_PREFIX + stylistControls.stylist.getID()"
                >
                  <ion-select-option
                    *ngFor="let timeslot of timeSlots"
                    [value]="timeslot.value"
                  >
                    {{timeslot.label}}
                  </ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Finish Duration</ion-label>
                <ion-select
                  [formControlName]="FINISH_DURATION_CONTROL_PREFIX + stylistControls.stylist.getID()"
                >
                  <ion-select-option
                    *ngFor="let timeslot of timeSlots"
                    [value]="timeslot.value"
                  >
                    {{timeslot.label}}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </div>
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col size="11">
                  <ion-item lines="none">
                    <ion-label class="sm-bold">Client Bookable</ion-label>
                    <!-- <ion-toggle [formControlName]="BOOKABLE_CONTROL_PREFIX + stylistControls.stylist.getID()"></ion-toggle> -->

                    <ion-checkbox
                      [formControlName]="BOOKABLE_CONTROL_PREFIX + stylistControls.stylist.getID()"
                    >
                    </ion-checkbox>
                  </ion-item>
                </ion-col>
                <ion-col size="1" class="sm-align-vertical">
                  <ion-icon
                    id="client-bookable-hover-trigger"
                    name="help-circle"
                    color="faint"
                    arrow="true"
                  ></ion-icon>
                  <ion-popover
                    trigger="client-bookable-hover-trigger"
                    triggerAction="hover"
                    side="right"
                    alignment="end"
                    size="auto"
                  >
                    <ng-template>
                      <ion-content class="ion-padding"
                        >Controls whether a client can book this service online
                        or not. Useful if you want some services like friends
                        and family cuts only to be bookable by you.</ion-content
                      >
                    </ng-template>
                  </ion-popover>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ng-container>
        </ion-card>
        <br />
      </ion-col>
      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </form>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col class="hidden-md-down" size="5"></ion-col>
        <ion-col *ngIf="service.getParentID()">
          <ion-button
            fill="outline"
            expand="block"
            color="danger"
            (click)="onDeleteServiceParent()"
            >Delete</ion-button
          >
        </ion-col>
        <ion-col *ngIf="!service.getParentID()"></ion-col>
        <ion-col>
          <ion-button
            fill="outline"
            expand="block"
            routerLink="/settings/services/manager"
          >
            Cancel
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" (click)="save()"> Save </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
